import React from 'react';
// styles
import styles from './styles.module.scss';
//components
import AddToCalendarComponent from '@/components/landing-page-templates/ConfigLandingPage/DisplayMessageComponents/AddToCalendarComponent';

const BeforeEventSection = ({
  event,
  currentUserEventPermissions,
  landingPageObject
}) => {

  const { formBgColour, formFontColour } = landingPageObject;

  let root = document.documentElement;
  root.addEventListener('mouseover', e => {
    root.style.setProperty('--background', formBgColour);
    root.style.setProperty('--font-color', formFontColour);
  });

  return (
    <>
      <div className={styles.outerSectionContainer}>
        <div className={styles.innerSectionContainer}>
          <ClockIcon />
        </div>
      </div>
      <div className={styles.mainHeading}>You’re <i>slightly</i> early</div>
      <div className={styles.heading}>The event has not started yet</div>
      <div className={styles.buttonElement}>
        <AddToCalendarComponent
          event={event}
          currentUserEventPermissions={currentUserEventPermissions}
        />
      </div>
    </>
  )
}

export default BeforeEventSection;

const ClockIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5 20C4.977 20 0.5 15.523 0.5 10C0.5 4.477 4.977 0 10.5 0C16.023 0 20.5 4.477 20.5 10C20.5 15.523 16.023 20 10.5 20ZM11.5 10V5H9.5V12H15.5V10H11.5Z" fill="black" />
  </svg>
);
